import React, { Component } from 'react';
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";
import * as moment from "moment";
import "moment/locale/pt-br";

export default class PDFDetalhesEntrega extends Component {
    render() {
        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.section}>
                        <View>
                            <Text style={{ fontWeight: 'bold', fontSize: 18, color: '#701B8C', marginBottom: 10 }}>
                                iFeira - Relatório de Entregas
                            </Text>
                            <Text style={{ fontWeight: 'bold', fontSize: 16, color: '#3D434D', marginBottom: 10 }}>
                                Entregador:
                                <Text style={{ fontSize: 16, color: "#701B8C" }}>
                                    {"  "}{this.props.entregador.label}
                                </Text>
                            </Text>
                            <View style={{ borderTopWidth: 1, }}>
                                <Text style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 10, marginTop: 10 }}>
                                    Periodo:
                                    <Text style={{ fontSize: 14, color: "#701B8C" }}>
                                        {"  "}{this.props.dataInicio ? moment(this.props.dataInicio).format("l") : '-'}
                                    </Text>
                                    <Text style={{ fontSize: 14, color: "#701B8C" }}>
                                        {"   à   "}{this.props.dataFim ? moment(this.props.dataFim).format("l") : '-'}
                                    </Text>
                                </Text>
                            </View>
                            <Text style={{ fontWeight: 'bold', fontSize: 16, color: '#3D434D', marginBottom: 10 }}>
                                Total de entregas:
                                <Text style={{ fontSize: 16, color: "#701B8C" }}>
                                    {"  "}{this.props.data.length}
                                </Text>
                            </Text>
                            <Text style={{ fontWeight: 'bold', fontSize: 16, color: '#3D434D', marginBottom: 10 }}>
                                Total faturado:
                                <Text style={{ fontSize: 16, color: "#701B8C" }}>
                                    {"  "}R$ {parseFloat(this.props.totalFaturado).toFixed(2).replace('.', ',')}
                                </Text>
                            </Text>
                            <View style={styles.table}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Data</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Código pedido</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Estabelecimento</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Cliente</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Frete</Text>
                                    </View>
                                </View>
                                {this.props.data.map((pedido, i) => (
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{moment(pedido.agendado ? pedido.dataAgendamento : pedido.createdAt).format("l")}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{pedido.codigo}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{pedido.estabelecimento.nome_fantasia}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{pedido.cliente.nome}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>R$ {parseFloat(pedido.detalhes_pagamento.frete).toFixed(2).replace('.', ',')}</Text>
                                        </View>
                                    </View>
                                ))}
                            </View>
                        </View>
                        <Text style={{ fontSize: 12, marginTop: 10 }}>
                            {"*Emitido em - "}{moment(Date.now()).format("l")} {moment(Date.now()).format("LT")}
                        </Text>
                    </View>
                </Page>
            </Document>
        );
    }
}

const styles = StyleSheet.create({
    page: {
        paddingBottom: 20
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    container: {
        padding: 20,
        backgroundColor: '#F5F6F8',
        height: '100%',
    },
    title: {
        fontSize: 22,
        color: "#000",
        paddingBottom: 20,
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableCol: {
        width: "20%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0
    },
    tableCell: {
        margin: "auto",
        marginTop: 5,
        fontSize: 10
    }
});